<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="68px">
      <el-form-item prop="iccid">
        <el-input v-model="queryParams.iccid" placeholder="ICCID"  @keyup.enter.native="handleQuery" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tableData" border v-loading="loading" >
      <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="iccid" label="ICCID" align="center"></el-table-column>
      <el-table-column prop="operation" label="状态" align="center"></el-table-column>
      <el-table-column prop="createTime" label="操作时间" align="center"></el-table-column>
      <el-table-column prop="reqReason" label="备注" align="center"></el-table-column>
      <el-table-column prop="operator" label="操作人" align="center"></el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
  </div>
</template>
<script>
import { stopWarnPage} from "@/api/api.js"; //获取卡源流量列表
export default {
  name: "poolCardStopWarn",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 搜索
      queryParams:{
        userId:"",
      },
      page: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
    };
  },
  computed: {},
  methods: {
    // 获取列表
    initData() {
      this.queryParams.userId = this.$route.params && this.$route.params.userId;
      let params = {
        model:{
          ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize
      };
      this.loading = true;
      stopWarnPage(params).then(res => {
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
        this.loading = false;
      });
    },
    handleQuery(){
      this.page = 1,
      this.initData();
    },
    resetQuery(){
      this.resetForm("queryForm");
      this.search();
    },
    /** 刷新 */
    refresh(row) {
      this.initData();
    },

  },
  mounted() {
  },
  created(){
    this.initData();
  }
};
</script>
<style scoped lang="less">

</style>


